// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAMt5dT0cybEkBO5nD54borSHglIgYUYuY",
  authDomain: "badi-dukkan.firebaseapp.com",
  projectId: "badi-dukkan",
  storageBucket: "badi-dukkan.appspot.com",
  messagingSenderId: "594537883555",
  appId: "1:594537883555:web:21c5cfa58c5c9941fedc16",
  measurementId: "G-BFD370MRYD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

console.log(analytics)

export {db}
